import type { ModifiersType } from '@boost-sd/classnames';
import { mergeModifiers } from '@boost-sd/classnames';
import { InnerHTMLRenderer } from '@boost-sd/core-js';
import { createClsNameMap } from '@utils';
import type { CSSProperties } from 'react';

const clsNameMap = createClsNameMap({
  modifiers: ['fill-current-color', 'on-right', 'is-image'],
})('icon');

export type IconProps = {
  innerSvg?: string;
  src?: string;
  modifiers?: ModifiersType<typeof clsNameMap, true>;
  style?: CSSProperties;
};

export const Icon = ({ innerSvg, src, modifiers, style }: IconProps) => {
  return (
    <InnerHTMLRenderer
      className={mergeModifiers(clsNameMap, [
        {
          'is-image': !!src,
        },
        modifiers,
      ])}
      as='span'
      html={innerSvg || ''}
      style={{
        ...style,
        backgroundImage: src ? `url('${src}')` : undefined,
      }}
    />
  );
};
